// NTA(mopita)成果報告システムの成果報告URL
const NTA_CONVERSION_URL = 'https://pit.mopita.com/if/portal/if_ext_conversion.aspx';
// サイト固有ID(cr)。mopitaから発行される固定値。
const NTA_CREATIVE_ID = '3638';
// 通信タイプ。ブラウザのimgタグによる報告なので"1"を送る
const NTA_ACT_IMG_TAG = '1';
export class NtaClient {
    constructor(config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = config;
    }
    // NTA(mopita)のコンバージョン用タグ。決済成功時に成果報告URLへGETを発火する
    // suid: leanbodyのユーザーID / ntaId: 流入時に保存した弊社識別情報
    loadConversionScript(suid, ntaId) {
        // 本番のみ計測する（stg/devの登録で広告ベンダーの計測データを汚さない）
        if (!this.config.isProduction)
            return;
        // 必須パラメータが揃っていない場合は発火しない
        if (!ntaId || !NTA_CREATIVE_ID || !suid)
            return;
        const params = new URLSearchParams({
            nta: ntaId,
            cr: NTA_CREATIVE_ID,
            suid: String(suid),
            act: NTA_ACT_IMG_TAG,
        });
        // 返却値はHTTPステータスのみのため、imgビーコンでGET発火（CORS回避）
        const img = document.body.appendChild(document.createElement('img'));
        img.src = `${NTA_CONVERSION_URL}?${params.toString()}`;
    }
}
